import { render, staticRenderFns } from "./approval-steps.vue?vue&type=template&id=7def6216&scoped=true&"
import script from "./approval-steps.vue?vue&type=script&lang=js&"
export * from "./approval-steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def6216",
  null
  
)

export default component.exports